import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
  children: ReactNode | ReactNode[];
  isBracketOption?: boolean;
};

const StyledCaption = styled.div<{ isBracketOption?: boolean }>`
  text-align: center;
  font: normal normal 300 14px/20px Lato;
  letter-spacing: 0.28px;
  color: #242325;
  max-width: 310px;
  margin: 7px auto 0px;
  min-height: 20px;

  @media (max-width: 1440px) {
    margin-top: 2px;
  }
  @media (max-width: 767px) {
    font-size: var(--bs-xs-font-size);
  }
  ${({ isBracketOption }) => {
    if(isBracketOption) return `margin: 0px; text-align: start;`
    else return `margin: 7px auto 0px; text-align: center;`
  }}
`;

export const Caption = ({ children, isBracketOption }: Props) => {
  return <StyledCaption isBracketOption={isBracketOption}>{children}</StyledCaption>;
};
